import { useLazyQuery, useQuery } from "@apollo/client/react"; import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Grid } from '@mui/material';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { adaptAreasReclamoArray, GET_ALL_AREAS_RECLAMO } from '../../../../data/graphQL/queries/Reclamos/getAllAreasReclamo';
import { adaptClasificacionesReclamoArray, GET_ALL_CLASIFICACIONES_IR } from '../../../../data/graphQL/queries/Reclamos/getAllClasificacionesIR';
import { adaptUsuariosResponsablesArray, GET_ALL_USUARIOS_RESPONSABLES } from '../../../../data/graphQL/queries/Reclamos/getAllUsuariosResponsables';
import EvaluacionField from './components/searchFields/EvaluacionField';
import { GroupedContainer } from '../../../ContratosCreation/components/GroupedContainer';
import { adaptCategoriasEFIArray, GET_ALL_CATEGORIAS_EFI } from '../../../../data/graphQL/queries/Reclamos/getAllCategoriasEFI';

export default function TabCalidadNH({
  editable,
  onChange,
  isEFI,
  reclamoFormData
}) {
  const [areas, setAreas] = useState([]);
  const [clasificaciones, setClasificaciones] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [categorias, setCategorias] = useState([]);

  const { data: areasData } = useQuery(GET_ALL_AREAS_RECLAMO, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!areasData) return;
    setAreas(adaptAreasReclamoArray(areasData));
	}, [areasData]);  

  const { data: categoriasData } = useQuery(GET_ALL_CATEGORIAS_EFI, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!categoriasData) return;
    setCategorias(adaptCategoriasEFIArray(categoriasData));
	}, [categoriasData]);  

  const { data: clasificacionesData } = useQuery(GET_ALL_CLASIFICACIONES_IR, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!clasificacionesData) return;
    setClasificaciones(adaptClasificacionesReclamoArray(clasificacionesData));
	}, [clasificacionesData]);  

  const [getUsuarios, { data: dataUsuarios, loading: usuariosLoading }] = useLazyQuery(GET_ALL_USUARIOS_RESPONSABLES, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!dataUsuarios) return;
    setUsuarios(adaptUsuariosResponsablesArray(dataUsuarios));
	}, [dataUsuarios]);  

  useEffect(() => {
    if (categoriasData) {
      setCategorias(adaptCategoriasEFIArray(categoriasData));
    }
  }, [categoriasData]);

  useEffect(() => {
    if (areasData) {
      setAreas(adaptAreasReclamoArray(areasData));
    }
  }, [areasData]);

  useEffect(() => {
    if (clasificacionesData) {
      setClasificaciones(adaptClasificacionesReclamoArray(clasificacionesData));
    }
  }, [clasificacionesData]);

  useEffect(() => {
    if (!usuariosLoading && !!reclamoFormData?.stage2?.idAreaReclamo) {
      getUsuarios({variables: { idAreaReclamo: reclamoFormData?.stage2?.idAreaReclamo }});
    }
  }, [reclamoFormData?.stage2?.idAreaReclamo]);

  const handleInputChange = useCallback((fieldName, value) => {
    onChange({
      [fieldName]: value
    });
  }, []);

  const updatedInputs = useMemo(() => {
    return structuredClone(inputs).
      filter((input) => isEFI ? !input.onlyReclamo : !input.onlyEfi).
      map((input) => {
        switch (input.name) {
          case 'idAreaReclamo':
            input.options = areas;
            break;
          case 'idClasificacionReclamo':
            input.options = clasificaciones;
            break;
          case 'idUsuarioResponsable':
            input.options = usuarios;
            input.disabled = !reclamoFormData?.stage2?.idAreaReclamo;
            break;
          case 'idCategoriaEFI':
            input.options = categorias;
            break;
          case 'descripcionCalidad':
            if (isEFI)
              input.displayName = 'Descripción EFI';
            break;
          default:
            break;
        }
        if (!editable) {
          input.disabled = true;
        }
        return input;
      });
  }, [
    editable,
    clasificaciones,
    areas,
    categorias,
    reclamoFormData?.stage2?.idAreaReclamo,
    usuarios]
  );

  return (
    <div>
      <Grid container spacing={2}>
        {updatedInputs.
          filter((input) => !input.positionFinal).
          map((input, index) =>
            <Grid key={`input-${input.name}-index-${index}`} size={{ xs: input.col }}>
              <RenderInputByTypeMobile
                key={`input-${input.name}-index-${index}`}
                input={input}
                handleChange={handleInputChange}
                value={reclamoFormData?.stage2[input.name]} />

            </Grid>
          )}
        <GroupedContainer sectionTitle='Contratos'>
          <Grid container size={{ xs: 100 }}>
            <EvaluacionField
              onChange={handleInputChange}
              evaluaciones={reclamoFormData?.stage2?.evaluaciones || []}
              disabled={!editable}
              idPaciente={reclamoFormData?.stage1?.idPaciente} />

          </Grid>
        </GroupedContainer>
        {isEFI && <GroupedContainer sectionTitle='Evaluación de impacto'>
          {updatedInputs.
            filter((input) => input.groupedImpacto).
            map((input, index) =>
              <Grid container size={{ xs: 100 }}>
                <RenderInputByTypeMobile
                  key={`input-${input.name}-index-${index}`}
                  input={input}
                  handleChange={handleInputChange}
                  value={reclamoFormData?.stage2[input.name]} />

              </Grid>
            )}
        </GroupedContainer>}
        {updatedInputs.
          filter((input) => input.positionFinal && !input.groupedImpacto).
          map((input, index) =>
            <Grid key={`input-${input.name}-index-${index}`} size={{ xs: input.col }}>
              <RenderInputByTypeMobile
                key={`input-${input.name}-index-${index}`}
                input={input}
                handleChange={handleInputChange}
                value={reclamoFormData?.stage2[input.name]} />

            </Grid>
          )}
      </Grid>
    </div>);

}

const inputs = [
  //row
  {
    name: 'idAreaReclamo',
    displayName: 'Area',
    requierd: true,
    type: 'select',
    options: [],
    col: 3
  },
  {
    name: 'idClasificacionReclamo',
    displayName: 'Clasificación IR',
    requierd: true,
    type: 'select',
    options: [],
    col: 3
  },
  {
    name: 'idCategoriaEFI',
    displayName: 'Categoría',
    onlyEfi: true,
    requierd: true,
    type: 'select',
    options: [],
    col: 3
  },
  {
    name: 'seguridadSaludPaciente',
    displayName: `Seguridad y salud del paciente`,
    type: 'custom_switch',
    onlyEfi: true,
    groupedImpacto: true,
    positionFinal: true,
    disabled: false,
    col: 3
  },
  {
    name: 'calidadServicio',
    displayName: `Calidad del servicio`,
    type: 'custom_switch',
    onlyEfi: true,
    groupedImpacto: true,
    positionFinal: true,
    disabled: false,
    col: 3
  },
  {
    name: 'justificacion',
    displayName: 'Justificación',
    type: 'long_string',
    onlyEfi: true,
    disabled: false,
    required: true,
    positionFinal: true,
    groupedImpacto: true,
    col: 12
  },
  {
    name: 'descripcionCalidad',
    displayName: 'Descripción',
    type: 'long_string',
    required: true,
    disabled: false,
    positionFinal: true,
    col: 12
  },
  {
    name: 'accionInmediataCalidad',
    displayName: 'Acción Inmediata',
    type: 'long_string',
    disabled: false,
    positionFinal: true,
    col: 12
  },
  {
    name: 'idUsuarioResponsable',
    displayName: 'Responsable',
    type: 'select',
    options: [],
    required: true,
    positionFinal: true,
    col: 3
  }];